import { useEffect } from "react";

const Seo = ({ title, description }) => {
    useEffect(() => {
        document.title = title ? `${title} — Panther City Clubhouse` : "Panther City Clubhouse — A Gathering Place for Weirdos";
        if (description) {
            let tag = document.querySelector('meta[name="description"]');
            if (tag) tag.setAttribute("content", description);
        }
    }, [title, description]);
    return null;
};

export default Seo;
